import { render, staticRenderFns } from "./FeedProductPartnerOrgsTab.vue?vue&type=template&id=533f0858&"
import script from "./FeedProductPartnerOrgsTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductPartnerOrgsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports